export const config = {
  getMyCollege: "https://apinavakarnatakanirmanawelfaretrust.vihaaninnovations.com",
  cookieName: "clg_user",
  sessionCookie: "clg_sess",
};
